import { useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";
import "./styles.css";
import NavItems from "./NavItems";
import { useTranslation } from "react-i18next";

const Alerts = (props: any) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("immigration");

  return (
    <Col lg="3" className="mb-4 mb-lg-0">
      <div className="alerts-section">
        <h6 className="alerts-title">ALERTS</h6>

        <div className="alert-item alert-warning mb-3">
          <div className="alert-icon">●</div>
          <div className="alert-content">
            <p className="alert-heading">Visa renewal due in 60 days</p>
            <p className="alert-desc">Work permit - expires 31 Dec 2025</p>
          </div>
        </div>

        <div className="alert-item alert-danger mb-3">
          <div className="alert-icon">●</div>
          <div className="alert-content">
            <p className="alert-heading">Missing tax document</p>
            <p className="alert-desc">Tax return 2025 - pending upload</p>
          </div>
        </div>

        <div className="alert-item alert-info mb-3">
          <div className="alert-icon">●</div>
          <div className="alert-content">
            <p className="alert-heading">Presence threshold nearing</p>
            <p className="alert-desc">Belgium - 150/183 days</p>
          </div>
        </div>

        <div className="alert-item alert-secondary">
          <div className="alert-icon">●</div>
          <div className="alert-content">
            <p className="alert-heading">Residence permit pending</p>
            <p className="alert-desc">Document upload required</p>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default Alerts;
